import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  Badge,
  Box,
  Button,
  Checkbox,
  IconButton,
  TableFooter,
  TablePagination,
  Tooltip,
  useTheme,
} from "@mui/material";
import moment from "moment/moment";
import {
  KeyboardArrowDown,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  KeyboardArrowUp,
  History,
  Print,
  Sell,
  Send,
  UnfoldMore,
  Visibility,
} from "@mui/icons-material";
import useTimer from "../../customHooks/useTimer";
import { useMemo } from "react";
import PropTypes from "prop-types";
import ButtonDropDown from "../ButtonDropDown";
import ButtonDropDownFulfilled from "../ButtonDropDownFulfilled";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    // color: "inherit",
    // color: "rgb(255, 255, 255)",
    // mixBlendMode: "difference",
    // "& .MuiCheckbox-root":{
    //   color:"#999"
    // },
  },

  "& svg": {
    position: "relative",
    cursor: "pointer",
  },
  "&:last-child": {
    mixBlendMode: "unset",

    "& svg": {
      // color:"#999",
      //   color: "rgb(255, 255, 255)",
      // mixBlendMode: "difference"
    },
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  color: "#999",
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const ActionBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "45px",
  [theme.breakpoints.down("md")]: {
    gap: "20px",
  },
}));


function TablePaginationActions(props) {
  const { count, page, rowsPerPage, onPageChange } = props;
  const theme = useTheme();

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  return (
    <div style={{ flexShrink: "0" }}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 1}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage)}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default function TableNotification(props) {
  const handleClickPrint = (val, row) => {
    props.handlePrint(val, row);
  };
  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              {props.columns.map((col, index) =>
                props.sort ? (
                  index === 0 ? (
                    <StyledTableCell
                      key={col.id}
                      onClick={() => props.handleSort(col.id)}
                    >
                      {props.currentColumn === col.id ? (
                        <span style={{ fontWeight: "700" }}>{col.name}</span>
                      ) : (
                        col.name
                      )}
                      {props.currentColumn === col.id ? (
                        props.direction === "asc" ? (
                          <KeyboardArrowUp fontSize="small" />
                        ) : (
                          <KeyboardArrowDown fontSize="small" />
                        )
                      ) : (
                        <UnfoldMore fontSize="small" />
                      )}
                    </StyledTableCell>
                  ) : (
                    <StyledTableCell
                      key={col.id}
                      align="right"
                      onClick={() => props.handleSort(col.id)}
                    >
                      {props.currentColumn === col.id ? (
                        <span style={{ fontWeight: "700" }}>{col.name}</span>
                      ) : (
                        col.name
                      )}
                      {props.currentColumn === col.id ? (
                        props.direction === "asc" ? (
                          <KeyboardArrowUp fontSize="small" />
                        ) : (
                          <KeyboardArrowDown fontSize="small" />
                        )
                      ) : (
                        <UnfoldMore fontSize="small" />
                      )}
                    </StyledTableCell>
                  )
                ) : index === 0 ? (
                  <StyledTableCell key={col.id}>{col.name}</StyledTableCell>
                ) : (
                  <StyledTableCell key={col.id} align="right">
                    {col.name}
                  </StyledTableCell>
                )
              )}
            </TableRow>
          </TableHead>
          <TableBody style={{ width: "100%", position: "relative" }}>
            {props.rows.length ? (
              props.rows.map((row) => {
                // var created = moment(new Date(row.created_at));
                // var ausDate = new Date()
                //   .toLocaleString("en-US", {
                //     timeZone: "Australia/Melbourne",
                //   })
                //   .toString();
                // var currentDate = moment(new Date(ausDate));
                // var diff = moment
                //   .duration(currentDate.diff(created))
                //   .asMinutes();

                return (
                  <StyledTableRow key={row.id}>
                    {props.columns.map((col, index) =>
                      col.id === "image" ? (
                        index === 0 ? (
                          <StyledTableCell
                            key={col.id}
                            component="th"
                            scope="row"
                          >
                            <img
                              src={
                                typeof row.image === "string"
                                  ? row.image
                                  : row.image[0]
                              }
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "contain",
                              }}
                              alt={row.firstname}
                            />
                          </StyledTableCell>
                        ) : (
                          <StyledTableCell key={col.id} align="right">
                            <img
                              src={row.image}
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "contain",
                              }}
                              alt={row.firstname}
                            />
                          </StyledTableCell>
                        )
                      ) : col.id === "check" ? (
                        <StyledTableCell key={col.id} align="right">
                          {props.openBackdrop &&
                            (props.checkedValues.includes(row.order?.id)) ? (
                            <h3 style={{ fontWeight: "700" }}>
                              {props.backdropNumber}...
                            </h3>
                          ) : (
                            <Checkbox
                              checked={props.checkedValues.includes(row.order?.id)}
                              onChange={(e) => props.handleCheck(e, row)}

                            />
                          )}
                        </StyledTableCell>
                      )  : (
                        <StyledTableCell key={col.id} align="right">
                          {col.id === "actions" && (
                            <ActionBox>
                              <Tooltip title="View Message">
                                <Visibility
                                  onClick={() => props.handleViewMessage(row)}
                                />
                              </Tooltip>

                              <Tooltip title="View History">
                                <Badge badgeContent={row.history?.length} color="primary">
                                <History
                                  onClick={() => props.handleViewHistory(row)}
                                />
                                </Badge>
                              </Tooltip>
                              
                              <Tooltip title="Resend Message">
                                <Send
                                  onClick={() => props.handleResendMessage(row)}
                                />
                              </Tooltip>
                              {props.handlePrint && (
                                
                                  <ButtonDropDownFulfilled
                                    handleClickPrint={handleClickPrint}
                                    row={row}
                                  />
                                
                              )}
                            </ActionBox>
                          )}

                          {(col.id === "created_at" || col.id === "updated_at" || col.id === "added" || col.id === "lastModified")
                            ? moment(row[col.id]).format(
                                "ddd, MMM Do YYYY, h:mm:ss a"
                              )
                            : col.id === "total"
                            ? "$" + row[col.id]
                            : col.id === "items"
                            ? row.sales_details?.length
                            : col.id === "pendingProcess"
                            ? row.pendingProcess === 0
                              ? "Success"
                              : row.pendingProcess === 1
                              ? "Pending"
                              : row.pendingProcess === 2 ? "Processing"
                              : "Error"
                            : 
                            col.id === "status" ?
                              row.status === "" ? "Pending" : row.status === null ? null  : row.status?.charAt(0).toUpperCase() + row.status?.slice(1) 
                            : row[col.id]}
                        </StyledTableCell>
                      )
                    )}
                  </StyledTableRow>
                );
              })
            ) : (
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  height: "50px",
                  position: "absolute",
                }}
              >
                <p>No Notification Found!</p>
              </Box>
            )}
          </TableBody>

          {props.footer !== false && (
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[20, 50, 70, 100]}
                  rowsPerPage={props.rowsPerPage}
                  page={props.page}
                  count={props.total && props.total}
                  SelectProps={{
                    native: true,
                  }}
                  labelDisplayedRows={() =>
                    `${props.from !== null ? props.from : "0"} - ${
                      props.to !== null ? props.to : "0"
                    } to ${props.total}`
                  }
                  onPageChange={props.handleChangePage}
                  onRowsPerPageChange={props.handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          )}
        </Table>
      </TableContainer>
    </Paper>
  );
}
